export default [

     {
          path: '/third-party-vendor-repository-entity',
          name: 'ThirdPartyVendorRepositoryEntity',
          component: () => import("@/views/Page/ThirdPartyVendorRepositoryEntity/ThirdPartyVendorRepositoryEntity.vue"),
           meta: {
               title: '#Default# | ThirdPartyVendorRepositoryEntity',
          },
     }
];